export enum TabKeysEnum {
  NEW = 'new',
  IN_PROGRESS = 'inProgress',
  SUBMITTED = 'submitted',
}
